/* CommitConfigurationComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CommitConfigurationRenderer");

/**
 * @class CommitConfigurationComponent
 * @extends EventEmitter
 *
 * @fires CommitConfigurationComponent#Shutdown
 *
 */
class CommitConfigurationComponent extends EventEmitter {
    constructor(data) {
        super();
        this._data = data;
        this._registerListeners();
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElem() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _triggerShutdown() {
        /**
         * @event CommitConfigurationComponent#Shutdown
         * @param {CommitConfigurationComponent}
         */
        this.emit("Shutdown", this);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        return Promise.all(shutDowns).then(
            () => {
                this.removeAllListeners();
                this._data = undefined;
            },
            (/*err*/) => {}
        );
    }

    reject(error) {
        this._context.reject(error);
    }

    resolve(data) {
        this._context.resolve(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    close() {
        this.resolve();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = CommitConfigurationComponent;
